import { Link } from "react-router-dom";
import { MapPin, Phone, Crown, ArrowRight, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/blocks";
import { NetworkMapSection } from "@/components/CentresMap";
import { IMAGES } from "@/data/content";
import { useCentre } from "@/context/CentreContext";
import { useUI } from "@/context/UIContext";

export default function Centres() {
  const { centres } = useCentre();
  const { openLead } = useUI();
  return (
    <div data-testid="centres-page">
      <Seo title="Nos centres Horsepower | Béziers, Montpellier, Perpignan, Marseille, Angers"
        description="Le réseau Horsepower : centre de Béziers (maison mère), Montpellier, Perpignan, Marseille et Angers. Reprogrammation moteur, E85 et banc de puissance près de chez vous."
        canonical="https://www.horsepowergarage.fr/centres" />
      <PageHero eyebrow="Réseau national" title="Nos centres Horsepower"
        subtitle="Un réseau de centres partout en France, une même exigence de performance et d'expertise technique."
        image={IMAGES.garage1} />

      <NetworkMapSection />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 pb-20">
        <div className="grid md:grid-cols-2 gap-8">
          {centres.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 2) * 0.08}>
              <div className="hp-card group overflow-hidden h-full flex flex-col sm:flex-row" data-testid={`centre-card-${c.slug}`}>
                <div className="relative sm:w-[45%] shrink-0 aspect-[3/4] overflow-hidden">
                  <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                  {c.is_mother && <span className="absolute left-4 top-4 flex items-center gap-1 bg-hp-yellow text-black text-[10px] font-bold uppercase tracking-wider px-2 py-1"><Crown size={12} /> Maison mère</span>}
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h2 className="font-display font-black text-2xl lg:text-3xl uppercase tracking-tight mb-4">{c.name}</h2>
                  <div className="space-y-2 text-sm text-neutral-400 flex-1">
                    {(c.address || c.postal_city) && <p className="flex items-start gap-2"><MapPin size={16} className="text-hp-yellow mt-0.5 shrink-0" />{[c.address, c.postal_city].filter(Boolean).join(", ")}</p>}
                    <p className="flex items-center gap-2"><Phone size={16} className="text-hp-yellow shrink-0" />{c.phone}</p>
                    {c.hours && <p className="flex items-center gap-2"><Clock size={16} className="text-hp-yellow shrink-0" />{c.hours}</p>}
                  </div>
                    <div className="flex flex-col gap-3 mt-6">
                    <Link to={`/centres/${c.slug}`} className="hp-ghost flex-1 text-center text-xs px-4 py-3 inline-flex items-center justify-center gap-1" data-testid={`centre-detail-link-${c.slug}`}>Découvrir le centre <ArrowRight size={13} /></Link>
                    <button onClick={() => openLead({ request_type: "rdv", centre_slug: c.slug })} className="hp-cta flex-1 text-xs px-4 py-3" data-testid={`centre-rdv-${c.slug}`}>Prendre rendez-vous</button>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
